export default __webpack_public_path__ + "static/media/limited_drinks@3x.58cc028c.jpg";